<script setup lang="ts">
import { cn } from '@/lib/utils';

const props = withDefaults(
    defineProps<{
        step: number;
        title: string;
        description: string;
        class?: string;
    }>(),
    { class: '' },
);
</script>

<template>
    <div
        :class="
            cn(
                'bg-card border-border flex h-full flex-col gap-3 rounded-xl border p-6',
                props.class,
            )
        "
    >
        <span class="font-display text-primary text-2xl leading-none">
            {{ String(props.step).padStart(2, '0') }}
        </span>
        <h3 class="text-lg">{{ props.title }}</h3>
        <p class="text-muted-foreground text-sm leading-relaxed">
            {{ props.description }}
        </p>
    </div>
</template>
